import { combineReducers } from 'redux';
import AuthReducer from './authReducer';
import AdminReducer from './adminReducer';
import TenantReducer from './tenantReducer';

const rootReducer = combineReducers({
  auth: AuthReducer,
  admin: AdminReducer,
  tenant: TenantReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js